import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route } from './Route';
import { useUrl } from './Hooks';

const RedirectProps = {
	path: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	allowReturnBack: PropTypes.bool,
};

export const Redirect = ({ path, to, allowReturnBack = false }) => {
	return (
		<Route
			path={path}
			render={<RedirectExe to={to} allowReturnBack={allowReturnBack} />}
		/>
	);
};

Redirect.propTypes = RedirectProps;

const RedirectExe = ({ to, allowReturnBack }) => {
	const { url, setUrl } = useUrl();

	useEffect(() => {
		if (url !== to) {
			setTimeout(() => setUrl(to, allowReturnBack), 0)
		}
	}, [url, to, setUrl, allowReturnBack]);

	return null;
};
